// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormEditReconciliationItem } from '../../forms/FormEditReconciliationItem/FormEditReconciliationItem';

// props
export interface DialogEditReconciliationItemProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogEditReconciliationItem = ({
	isOpen,
	onClose,
	onSuccess,
}: DialogEditReconciliationItemProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('saveReconciliationItem'),
					loading: isLoading,
					form: 'form-edit-reconciliation-item',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={600}
			onClose={onClose}
			title={{
				children: t('editReconciliationItem'),
				variant: 'h3',
			}}>
			<FormEditReconciliationItem
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
			/>
		</DialogActions>
	);
};
